module.exports = __webpack_public_path__ + "static/fonts/SFProDisplay-Regular.c9d4c1c.eot";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/fonts/SFProDisplay-Regular/SFProDisplay-Regular.eot
// module id = RJWB
// module chunks = 24